import Styles from './styles.module.scss';

import type { DeviceInfoModel } from '@/features/Organization/model/types/system-status.model';

import { WatchIcon } from '@/components/Elements/Icons';

interface Props {
	devices: DeviceInfoModel[];
}

export const DevicesList = ({ devices }: Props) => {
	return (
		<div className={Styles.devicesListContainer}>
			<div className={Styles.grid}>
				<WatchIcon />
				<span>Devices</span>
				<div className={Styles.list}>
					{devices.map((device, index) => (
						<DeviceInfo
							key={index}
							name={device.name}
							isConnected={device.isConnected}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

const DeviceInfo = ({ name, isConnected }: { name: string; isConnected: boolean }) => {
	if (!name) return null;

	return (
		<div className={Styles.device}>
			<div className={`${Styles.statusIndicator} ${isConnected ? Styles.on : Styles.off}`} />
			<span>{name}</span>
		</div>
	);
};
